export default __webpack_public_path__ + "static/media/Seek-1-2.a3e20c10.png";